import { ModalService } from '@features/modals/services/modal.service';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { KingHistory } from '../interfaces/king.interface';
import { ClipboardService } from '@core/services/clipboard.service';
import { SkinsRowComponent } from '../../components/skins-row/skins-row.component';
import { FairnessButtonComponent } from '../../../core/components/fairness-button/fairness-button.component';
import { KingUserAvatarComponent } from '../../../features/king/king-user-avatar/king-user-avatar.component';
import { CostComponent } from '../../../core/components/cost/cost.component';

@Component({
  selector: 'app-king-row',
  templateUrl: './king-row.component.html',
  styleUrls: ['./king-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    SkinsRowComponent,
    FairnessButtonComponent,
    KingUserAvatarComponent,
    CostComponent,
  ],
})
export class KingRowComponent {
  public readonly clipboardService = inject(ClipboardService);
  private readonly modalService = inject(ModalService);

  game = input.required<KingHistory>();
  skins = computed(() => {
    const skins = [
      ...(this.game().part?.skins ?? []),
      ...(this.game().king?.skins ?? []),
    ];
    return skins.sort((a, b) => b.price - a.price);
  });

  onClick() {
    this.modalService.openModal('KingSkinsModal', {
      kingGame: this.game(),
      skins: this.skins(),
      totalValue:
        (this.game().king?.value ?? 0) + (this.game().part?.value ?? 0),
    });
  }
}
